import React from 'react';
import request from 'superagent';
import SvgIcon from './presentation/SvgIcon';
import constants from './constants';
import urls from './urls';
import SpinnerIcon from './assets/images/svgs/spinner.svg';
import { goBack } from 'react-router-redux';

const Months = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function autobind(methodNames, instance) {
    methodNames.forEach((methodName) => {
        instance[methodName] = instance[methodName].bind(instance);
    });
}

export function debounce(func, wait, context) {
    var timeout, args, timestamp, result;

    var later = function() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) {
            timeout = setTimeout(later, wait - last);
        } else {
            timeout = null;
            result = func.apply(context, args);
            args = null;
        }
    };

    return function() {
        args = arguments;
        timestamp = Date.now();
        if (!timeout) {
            timeout = setTimeout(later, wait)
        };
        return result;
    };
};

export function debounceWithImmediate(func, wait, immediate, context) {
    var timeout;
    return function() {
        var args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

export function truncateText(str, maxLength, endString) {
    if(!str) {
        return;
    }
    if(!maxLength) {
        maxLength = 25;
    }
    if(str.length > maxLength) {
        str = str.substring(0, maxLength - endString.length) + endString;
    }
    return str;
}

export function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function getFormattedDate(timeStamp) {
    const date = new Date(timeStamp);
    return {
        dd: date.getDate(),
        mm: Months[date.getMonth()],
        yyyy: date.getFullYear()
    };
}

export function getPageLoadingDom() {
    return (
        <div className="loading-container hflex">
            <div className="loading">
                <SvgIcon glyph={SpinnerIcon} width='72px' height='72px'/>
                <p className="pumpkin-orange" style={{marginTop:"0.7em"}}>Loading</p>
            </div>
        </div>
    );
}

export function getLoadingDom() {
    return (
        <div className="small-loading-container">
            <div className="small-loading">
                <SvgIcon glyph={SpinnerIcon} width='72px' height='72px'/>
                <p className="pumpkin-orange" style={{marginTop:"0.7em"}}>Loading</p>
            </div>
        </div>
    );
}

export function checkHttpStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        var error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}

export function parseJSON(response) {
    return response.json();
}

export function goBackInHistory() {
    return (dispatch, getState) => {
        dispatch(goBack());
    };
}

export const commonHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=UTF-8'
}

export function storeLocally(itemName, itemValue) {
    localStorage.setItem(itemName, JSON.stringify(itemValue));
}

export function getFromLocalStorage(key) {
    const value = localStorage.getItem(key);
    if(value) {
        return JSON.parse(value);
    }
}

export function removeFromLocalStorage(key) {
    localStorage.removeItem(key);
}

export function getUploadUrl(mime, fileName) {
    const uploadUrl =`${constants.BASE_API_URL}${urls.STORAGE}presignedUrl?contentType=${mime}&fileName=${fileName}`;
    return new Promise((resolve, reject) => {
        request.get(uploadUrl)
        .set('Content-Type', 'application/json')
        //.set('Authorization', 'Bearer ' + token)
        .end((error, res) => {
            if(error) reject(error);
            if(res.statusCode < 200 || res.statusCode > 299) reject(error);
            resolve(res);
        })
    });
}

export function uploadContent(url, file, mime) {
    return new Promise((resolve, reject) => {
        request.put(url)
            .set('Content-Type', mime)
            .send(file)
            .end((error, res) => {
                if(error) reject(error);
                if(res.statusCode !== 200) reject(error);
                resolve(res);
            })
        })
}

export function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function formatDuration(durationInSeconds) {
    let mins = parseInt(durationInSeconds / 60);
    let seconds = durationInSeconds % 60;
    let hours, days, durationString = "";
    if(mins >= 60) {
        hours = parseInt(mins / 60);
        mins = mins % 60;
        if(hours >= 24) {
            days = parseInt(hours / 24);
            hours = hours % 24;
        }
    }
    if(days) {
        durationString += `${days} days `;
    }
    if(hours) {
        hours = hours.toString();
        hours = hours.length === 1 ? `0${hours}` : hours;
        durationString += `${hours}:`;
    }
    mins = mins.toString();
    mins = mins.length === 1 ? `0${mins}` : mins;
    durationString += `${mins}:`;

    seconds = seconds.toString();
    seconds = seconds.length === 1 ? `0${seconds}` : seconds;
    durationString += `${seconds}`;
    return durationString;
}


// WEBPACK FOOTER //
// ./src/utils.js